const key = "authToken@wholesaleManagement";

const getToken = () => {
  return localStorage.getItem(key);
};

const setToken = token => {
  return localStorage.setItem(key, token);
};

const removeToken = () => {
  localStorage.removeItem(key);
};

const setTokens = ({ accessToken, refreshToken }) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
};

const getRefreshToken = () => localStorage.getItem("refreshToken");

const TokenPersistenceManager = {
  getToken,
  setToken,
  removeToken,
  setTokens,
  getRefreshToken,
};

export default TokenPersistenceManager;
